import styled from "styled-components";

export const MainPhotoSection = styled.section`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 12rem 0rem 10rem 0rem;
  color: #fff;
  overflow: hidden;

  .flex__column {
    flex-direction: row;
  }

  .adaptive__column{
    flex-direction: row;
}
  .alight__left {
    align-self: center;
  }

  & p {
    margin: 1.875rem 0rem 3.125rem 0rem;
  }
  & a {
    width: 9.375rem;
  }
  & img {
    width: 31.25rem;
    margin-left: 9.375rem;
  }

  @media (max-width: 999px) {
    padding: 12rem 0rem 6rem 0rem;
    & img {
      width: 25.25rem;
      margin-left: 0px;
    }
  }

  @media (max-width: 768px) {
    padding: 7rem 0rem 6rem 0rem;
    & p {
      margin: 1.875rem 0rem;
    }
    & img {
      width: 21.25rem;
    }
  }

  @media (max-width: 400px){
    & img {
      width: 18.25rem;
    }
  }

  @media(max-width:821px){
      .adaptive__column{
    flex-direction: column;
}
  }

  @media (max-width: 631px) {
    padding: 8rem 0rem 2rem 0rem;

    .alight__left {
      align-self: baseline;
    }
    .flex__column {
      flex-direction: column;
    }
  }
`;

export const HowToStartSection = styled.section`
  .cards__container {
    height: 36.25rem;
    margin-top: 3.75rem;
  }

  .middle {
    height: 100%;
    padding: 0rem 2.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 2.5rem;
  }

  @media (max-width: 1330px) {
    & h2 {
      margin-bottom: 3.75rem;
    }

    .cards__container {
      height: fit-content;
      display: inline;
      & p {
        font-size: 2.2rem;
        font-weight: 500;
      }
    }
    .middle {
      margin: 2.5rem 0rem;
      flex-direction: row;
      padding: 0;
      gap: 20px;
    }
  }

  @media (max-width: 999px) {
    & img {
      width: 9.375rem;
    }
    .cards__container {
      & p {
        font-size: 1.3rem;
      }
    }
    .middle {
      flex-direction: column;
      margin: 20px 0px;
    }
  }

  @media (max-width: 768px) {
    & img {
      display: none !important;
    }
  }

  @media (max-width: 370px){
    .cards__container {
      & p {
        font-size: 1.15rem;
      }
    }
  }
`;

export const WebTerminalSection = styled.section`
  background-color: #001b48;
  color: #fff;

  & a {
    margin-top: 1.875rem;
    width: fit-content;
  }

  .big__text {
    margin: 3.75rem 0rem 1.875rem 0rem;
  }

  .web-terminal__info {
    width: 50%;
  }

  .web-terminal__photo {
    width: 40%;

    & div {
      width: 100%;
      & img {
        width: 100%;
      }
    }
  }

  @media (max-width: 999px) {
    .web-terminal__container {
      flex-direction: column;
    }
    .web-terminal__photo {
      width: 100%;
      overflow: hidden;
      margin-top: 1.25rem;
      & img {
        transform: scale(1.03);
      }
    }
    .web-terminal__info {
      width: 100%;
    }
  }
    @media (max-width: 370px){
       .big__text {
      margin: 1.875rem 0rem 1.875rem 0rem;
  }
    }
`;

export const AdvantagesSection = styled.section`
  & h2 {
    margin-bottom: 3.75rem;
  }

  .flex__between {
    flex-wrap: wrap;
    gap: 0.625rem;
  }
`;

export const InvestSection = styled.section`
  background-color: #001b48;
  color: #fff;

  & ul {
    & li {
      margin: 0.625rem 0rem;
      padding: 0rem 1.25rem;
      position: relative;
    }
    & li::before {
      content: "";
      width: 0.375rem;
      height: 0.375rem;
      background: #fff;
      position: absolute;
      left: 0;
      top: calc(50% - 3px);
    }
  }

  .big__text {
    margin: 3.75rem 0rem 1.875rem 0rem;
  }

  .web-terminal__info {
    width: 50%;
    & a {
      margin-top: 1.875rem;
      width: fit-content;
    }
  }

  .web-terminal__photo {
    width: 40%;

    & div {
      width: 100%;
      & img {
        width: 100%;
      }
    }
  }

  @media (max-width: 999px) {
    .web-terminal__container {
      flex-direction: column;
    }
    .web-terminal__info {
      width: 100%;
    }

    .web-terminal__photo {
      width: 100%;
      overflow: hidden;
      margin-top: 1.25rem;
      & img {
        transform: scale(1.03);
      }
    }
  }

  @media (max-width: 370px){
    .big__text {
      margin: 1.875rem 0rem 1.875rem 0rem;
    }
  }
`;
export const EconomicCalendarSection = styled.section`
  background-color: #f1f1f1;

  .economic__top {
    margin-bottom: 3.75rem;

    @media(max-width:550px){
      flex-direction: column;
      margin-bottom: 1.75rem;

      & a{
        margin-top: 1.25rem;
      }
    }
  }

  .economic__bottom {
    width: 100%;
    height: 37.5rem;
    & iframe {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 1330px) {
    .economic__bottom {
      height: 25.5rem;
    }
  }
  @media (max-width: 768px) {
    .economic__bottom {
      height: 32rem;
    }
  }
`;

export const MarketDynamicsSection = styled.section`
  .section__frame {
    width: 100%;
    height: 37.5rem;
    margin-top: 3.75rem;
    & iframe {
      width: 100%;
      height: 100%;
    }
  }
`;

export const IncreaseSection = styled.section`
  background-color: #001b48;
  color: #fff;
  padding: 0 !important;
  overflow: hidden;

  .web-terminal__info {
    width: 50%;

    .big__text {
      margin: 2.5rem 0rem;
    }

    & h2 {
      max-width: 38.5rem;
    }
    & a {
      margin-top: 1.875rem;
      width: fit-content;
    }
  }
  .web-terminal__photo {
    width: 50%;
    height: 34.375rem;
    position: relative;
    & img {
      position: absolute;
      top: 0;
      left: 0;
      width: 50vw;
      height: 100%;
    }
  }

  @media (max-width: 1330px) {
    .web-terminal__photo {
      height: 25.375rem;
    }
  }

  @media (max-width: 999px) {
    .web-terminal__info {
      width: 100%;
      padding: 40px 0px;
    }
    .web-terminal__photo {
      display: none;
    }
  }
`;
